import { Controller } from "stimulus";
import Swiper from "swiper";

export default class extends Controller {
  connect() {
    this.groupSwiper = new Swiper('.image-with-slider__slider', {
      loop: true,
      navigation: {
        prevEl: '.image-with-slider__prev',
        nextEl: '.image-with-slider__next',
      },
      autoHeight: true
    });
  }

  toggleHighlight(event) {
    let clickedElement = event.currentTarget;

    if (!clickedElement.classList.contains('.image-with-slider__nav-btn-highlighted')) {

      let actionElement = document.querySelector('.image-with-slider__nav-btn-highlighted')
      actionElement.classList.remove('image-with-slider__nav-btn-highlighted')
      clickedElement.classList.add('image-with-slider__nav-btn-highlighted')
    }
  }
}
